import "./currencyCard.scss";

import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import whiteChart from "../../assets/icons/icones moj-10-white.svg";
import chart from "../../assets/icons/icones moj-10.svg";
import downArrow from "../../assets/icons/icones moj-16.svg";
import upArrow from "../../assets/icons/icones moj-17.svg";
import ChartModal from "../ChartModal";

const CurrencyCard = ({ isPopular, currency }) => {
  // flag import
  const flagSvg = require(`../../assets/images/icons/flags/1x1/${currency?.Currency?.symbol}.svg`);

  const { REACT_APP_URL } = process.env;

  // states
  const [modalOpen, setModalOpen] = useState(false);
  const [buyPrices, setBuyPrices] = useState([]);
  const [sellPrices, setSellPrices] = useState([]);

  // store
  const darkThemeFromStore = useSelector((state) => state.Reducer.darkTheme);

  useEffect(() => {
    fetch(`${REACT_APP_URL}/api/currency-archive`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        currencyId: currency?.CurrencyId,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // Extract buyPrices and sellPrices into separate arrays
        setBuyPrices(data.data.map((item) => parseFloat(item.buyPrice)));
        setSellPrices(data.data.map((item) => parseFloat(item.sellPrice)));
      })
      .catch((err) => console.log(err));
  }, []);

  // handlers
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <div
      className={`currency-card-container ${isPopular ? "" : "smaller"} ${
        darkThemeFromStore ? "dark-back dark-br" : ""
      } ${darkThemeFromStore && isPopular ? "dark-back2" : ""}`}
    >
      <div className="currency-name">
        <div className="flag">
          <img src={flagSvg} alt={currency?.Currency?.symbol} />
        </div>
        <div>
          <div>
            <h3>{currency?.Currency?.name}</h3>
          </div>
          <div className="symbol">
            <h3>{currency?.Currency?.symbol}</h3>
          </div>
        </div>
      </div>
      <div className="chart">
        <img
          src={darkThemeFromStore ? whiteChart : chart}
          alt={currency?.Currency?.symbol}
          onClick={openModal}
        />
        <ChartModal
          isOpen={modalOpen}
          onClose={closeModal}
          buyPrices={buyPrices.slice().reverse()}
          sellPrices={sellPrices.slice().reverse()}
        />
      </div>
      <div className="price">
        <div className="price-item">
          <h4>فروش: </h4>
          <span className="mr-right font-hel">
            {currency?.sellPrice.toLocaleString()}
            <img
              src={
                currency?.sellPrice > currency?.pSellPrice ? upArrow : downArrow
              }
              alt=""
            />
          </span>
        </div>
        <div className="price-item">
          <h4>خرید: </h4>
          <span className="mr-right font-hel">
            {currency?.buyPrice.toLocaleString()}
            <img
              src={
                currency?.buyPrice > currency?.pBuyPrice ? upArrow : downArrow
              }
              alt=""
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default CurrencyCard;
